import { FabricChannel } from '@atlaskit/analytics-listeners';

export const ANALYTICS_CHANNEL: FabricChannel.aiMate = FabricChannel.aiMate;

export type InteractionSource =
	| 'chatInput'
	| 'embeddedAgentConversationStarters'
	| 'emptyStateSuggestions'
	| 'followUps'
	| 'inlineRovo'
	| 'movedOver'
	| 'ntpSuggestion'
	| 'profileCardConversationStarters'
	| 'remix'
	| 'remixModalFromToolbar'
	| 'remixModalFromBlockControls'
	| 'remixModalFromBlockMenu'
	| 'remixModalFromFloatingToolbar'
	| 'remixModalFromViewPageFloatingToolbar'
	| 'remixModalFromViewPageNudge'
	| 'remixModalFromNudge'
	| 'remixModalFromObjectLevelSidebar'
	| 'remixModalFromPasteMenu'
	| 'rightClickDefine'
	| 'rightClickSummarize'
	| 'urlParam'
	| 'viewAgentConversationStarters'
	| 'resendMessage'
	| 'remixStagingArea'
	| 'smartCreate'
	| 'mcpServerToolsRenderer'
	| 'executePythonRenderer'
	| 'askQuestionRenderer'
	| 'planCompleteRenderer'
	| 'jsmCreateRequestActionUnifiedRenderer'
	| 'jsmLivechatActionRenderer'
	| 'jsmCreateSpaceAction'
	| 'multipleChoiceQuestionsToolRenderer'
	| 'agenticPlanToolRenderer'
	| 'remixModalFromMediaInserts';

// Which context a follow up was triggered from
export type FollowUpSource =
	| 'ai-mate'
	| 'extension'
	| 'none'
	| 'page-summary'
	| 'reading-aids'
	| 'sain'
	| 'ai-smart-button-dynamic-surface'
	| string;

export enum AUTOSUGGEST_SOURCE {
	ROVO_CHAT = 'rovo-chat',
	CONFLUENCE_AIFC = 'confluence-aifc',
	CONFLUENCE_AIFC_SLIDES = 'confluence-aifc-slides',
	CONFLUENCE_AIFC_WHITEBOARD = 'confluence-aifc-whiteboard',
	CONFLUENCE_AIFC_DATABASE = 'confluence-aifc-database',
	CONFLUENCE_AIFC_LIVE_DOC = 'confluence-aifc-live-doc',
}
